<template>
  <!--右侧树形展示所有停车场-->
  <div class="trees">
    <el-input
      class="search"
      placeholder="输入关键字"
      v-model="filterText"
    ></el-input>
    <el-tree
      ref="tree"
      :data="allDatas"
      :props="defaultProps"
      @node-click="handleTreeClick"
      node-key="id"
      :highlight-current="true"
      :show-checkbox="false"
      :expand-on-click-node="true"
      :default-expanded-keys="expandedKeys"
      :filter-node-method="filterNode"
      @node-expand="handleNodeExpand"
    >
      <span slot-scope="{ node, data }" class="group">
        <span>
          <span class="group-name" v-if="data.type == 'admin'">{{
            node.label
          }}</span>
          <span class="group-name" v-if="data.type == 'group'">
            <span class="group-name-tip">集团</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'property'">
            <span class="group-name-tip">物业</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'parking'">
            <span class="group-name-tip">车场</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'shops'">
            <span class="group-name-tip">商户</span>
            {{ node.label }}
          </span>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
import { getDepartTree } from "@/api/url";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      allDatas: [],
      showArea: false,
      showBox: false,
      showChannel: false,
      nodeKeys: [],
      expandedKeys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      dialogFormVisible: false,
      delDialogFormVisible: false,
      form: {
        id: "",
        type: "",
        parentId: "",
        name: "",
        person: "",
        phone: "",
      },
      delForm: {
        id: "",
        password: "",
      },
    };
  },
  props: {
    moduleName: String,
    areaId: String,
  },
  methods: {
    ...mapMutations(["getPage"]),
    getAllDatas: function () {
      var _this = this;
      this.$get(getDepartTree(), {}).then((data) => {
        console.log("获取树形数据", data);
        if (this.moduleName == "shops") {
          this.allDatas = data?.[0]?.children ?? [];
        } else {
          let temp = this.getDataByType("parking", data[0]);
          this.allDatas = temp?.children ?? [];
        }
        // 清空之前的节点keys
        this.expandedKeys = [];
        // 递归获取第一个节点的所有子节点ID
        if (this.allDatas && this.allDatas.length > 0) {
          this.getAllNodeIds(this.allDatas[0]);
          // 保存展开状态
          sessionStorage.setItem(
            "expandedNodes",
            JSON.stringify(this.expandedKeys)
          );
        }
        console.log("treeData",this.allDatas);
        // 保存数据到session
        sessionStorage.setItem("treeData", JSON.stringify(this.allDatas));
      });
    },
    // 递归获取所有子节点ID
    getAllNodeIds(node) {
      if (!node) return;

      // 添加当前节点ID
      this.expandedKeys.push(node.id);

      // 递归处理所有子节点
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          this.getAllNodeIds(child);
        });
      }
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (data, node) {
      
      this.getPage({
        curIndex: 1,
        rowsCount: 0,
      });

      // 保存当前选中的节点
      sessionStorage.setItem(
        "selectedNode",
        JSON.stringify({
          id: data.id,
          type: data.type,
          name: data.name,
        })
      );
   
      // 保存当前展开的节点
      sessionStorage.setItem(
        "expandedNodes",
        JSON.stringify(this.expandedKeys)
      );

      this.$emit("handleTreeClick", data);
    },

    // 新增：处理节点展开事件
    handleNodeExpand(data) {
      // 清空之前的节点keys
      this.expandedKeys = [];
      // 确保不重复添加
      if (!this.expandedKeys.includes(data.id)) {
        this.expandedKeys.push(data.id);
      }
    },
    setCurrent(id) {
      this.$refs.tree.setCurrentKey(id);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getDataByType(type, data) {
      // 基础数据提取函数
      const extractBaseData = (node) => ({
        type: node.type,
        name: node.name,
        contact: node.contact,
        mobile: node.mobile,
        id: node.id,
        parentId: node.parentId,
        address: node.address,
      });

      // 如果没有数据，直接返回null
      if (!data) return null;

      // 如果当前节点类型匹配，返回基础数据
      if (data.type === type) {
        return extractBaseData(data);
      }

      // 如果没有子节点，返回null
      if (!Array.isArray(data.children) || data.children.length === 0) {
        return null;
      }

      // 递归处理子节点
      const children = data.children
        .map((child) => this.getDataByType(type, child))
        .filter(Boolean);

      // 如果没有找到匹配的子节点，返回null
      if (children.length === 0) {
        return null;
      }

      // 返回当前节点数据（包含过滤后的子节点）
      return {
        ...extractBaseData(data),
        children,
      };
    },
    permiss() {
      this.property_btn_add = this.elements["property:btn_add"];
      this.property_btn_edit = this.elements["property:btn_edit"];
      this.property_btn_remove = this.elements["property:btn_remove"];
      this.grouplist_btn_add = this.elements["grouplist:btn_add"];
      this.grouplist_btn_edit = this.elements["grouplist:btn_edit"];
      this.grouplist_btn_remove = this.elements["grouplist:btn_remove"];
    },
  },
  created() {
    this.permiss();
  },
  mounted() {
    this.permiss();
    // 尝试从session恢复数据
    const savedTreeData = sessionStorage.getItem("treeData");
    console.log("尝试从session恢复数据", savedTreeData);
    if (savedTreeData&&savedTreeData.length > 0) {
      this.allDatas = [...JSON.parse(savedTreeData)];
      // 恢复展开状态
      const savedExpandedNodes = sessionStorage.getItem("expandedNodes");
      if (savedExpandedNodes) {
        this.expandedKeys = [...JSON.parse(savedExpandedNodes)];
      }
      // 恢复选中状态
      const savedSelectedNode = sessionStorage.getItem("selectedNode");
      if (savedSelectedNode) {
        const selectedNode = JSON.parse(savedSelectedNode);
    
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(selectedNode.id);
        });
        this.$emit("handleTreeClick", selectedNode);
      }
    } else {
      console.log("没有保存的数据，重新获取树形数据");
      // 如果没有保存的数据，则重新获取
      this.getAllDatas();
    }
  },
  computed: {
    ...mapState({
      elements: (state) => state.elements,
    }),
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
.parkClass {
  display: inline-block;

  height: 15px;
  line-height: 15px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/park.png) no-repeat left center;
  padding-left: 20px;
  /*font-weight: bold;*/
  color: #606266;
  font-size: 14px;
}
.areaClass {
  display: inline-block;
  line-height: 15px;
  height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/area.png") no-repeat left center;
  padding-left: 20px;
}
.spaceClass {
  display: inline-block;
  width: 10px;
  height: 10px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/space.png) no-repeat center center;
}
.el-tree {
  color: #5c5c5c !important;
  height: calc(100vh - 130px);
  overflow: auto;

  width: 100%;
}
.is-current {
  background: #afc0e9 !important;
}
.trees {
  border-right: 10px solid #eff2f7;
  padding: 10px 5px 0 5px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #ccc !important;
}

.isActive {
  background: #ccc !important;
}
.search {
  border-radius: 10px !important;
  margin-bottom: 10px;
}
.tree-tip {
  font-size: 10px;
  color: red;
}

.add {
  color: #409eff;
}
.edit {
  color: #67c23a;
}
.delete {
  color: #f56c6c;
}
.group-name-tip {
  color: red;
  font-size: 10px;
}
</style>
<style>
.trees .search .el-input__inner {
  border-radius: 4px;
}
</style>